/**
 * @generated SignedSource<<99b97bee77f74e176eb19a01e53994b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectPickerProject$data = {
  readonly closed: boolean;
  readonly id: string;
  readonly number: number;
  readonly title: string;
  readonly viewerCanUpdate: boolean;
  readonly " $fragmentType": "ProjectPickerProject";
};
export type ProjectPickerProject$key = {
  readonly " $data"?: ProjectPickerProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPickerProject">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ProjectPickerProject"
};

(node as any).hash = "e09e5594bd0a134c07d1a00480ae9ec9";

export default node;
